<template src="../../components/shared/contacts/NewContactTemplate.html">
</template>

<script>
    import GenericProfileInfo from "./GenericProfileInfo.vue";
    import {api} from "../../global/framework/api.js";

    export default {
        name: "NewContactModal",
        components: {GenericProfileInfo},
        data() {
            return {
                controllerName: "",
                entityId: null,
                vm: {},
                profileInfoData: {},
                isCompany: false
            }
        },
        methods: {
            async showModal({entityId, controllerName}) {
                this.entityId = entityId;
                this.controllerName = controllerName;
                if(this.controllerName === "Company") this.isCompany = true;
                //console.log("data under contact modal: ", this.$data, "controllerName:", controllerName);
                let data = await api.get("Shared", entityId, "GetAddContactModel");
                this.mapData('vm', data);
                this.mapData('profileInfoData', data);//Inner component was deleting properties...
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async addNewContact() {
                //console.log("vm inside new contact: --Save--", this.$data.vm);
                let result = await api.post(this.controllerName, "SaveNewContact", {...this.$data.vm, ...this.$data.profileInfoData});
                if (result) {
                    this.$refs.modalRef.close();
                    this.$bus.$emit(this.$AcEvents.CONTACT_CHANGE, result);
                }
            }
        }
    }
</script>

<style scoped>
    .box {
        min-height: 100px !important;
    }
</style>